import React from "react";
import { Link } from "react-router-dom";

import withMotion from "../../Utils/withMotion";
import "./ThankYou.scss";

const ThankYou = () => {
  return (
    <div className="container thank-you-container text-center mb-5">
      <div className="success-container">
        <p className="mb-5">
          Thank you for contacting us! We will get back to you shortly to
          schedule your appointment.
        </p>
        <p className="return-message pb-5">
          Return to the&nbsp;
          <Link className="text-blue" to="/">
            home page
          </Link>
        </p>
      </div>
    </div>
  );
};

export default withMotion(ThankYou);
